import { put, takeLatest } from 'redux-saga/effects';

import {
  TOGGLE_SIDEBAR_REQUEST,
  TOGGLE_SIDEBAR_SUCCESS,
  // @ts-ignore
} from '@/action-types/sidebar';

export function* toggleSidebar(params: { isOpen: boolean; }) {
  yield put({ type: TOGGLE_SIDEBAR_SUCCESS, isOpen: params.isOpen });
}

export default function* sidebar() {
  // @ts-ignore
  yield takeLatest(TOGGLE_SIDEBAR_REQUEST, toggleSidebar);
}
